import * as React from "react";
import type { SVGProps } from "react";
const SvgQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M2 6.75c0-.414.32-.75.714-.75h1.221c3.92 0 7.097 2.955 7.097 6.6v4.65c0 .414-.32.75-.714.75H7.876c-.395 0-.715-.336-.715-.75V12.6c0-1.657-1.444-3-3.226-3h-1.22C2.32 9.6 2 9.264 2 8.85zm10.968 0c0-.414.32-.75.714-.75h1.221C18.823 6 22 8.955 22 12.6v4.65c0 .414-.32.75-.714.75h-2.443c-.394 0-.714-.336-.714-.75V12.6c0-1.657-1.444-3-3.226-3h-1.221c-.395 0-.714-.336-.714-.75z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuote;
